<button
  mhFilterTrigger
  [filterOpen]="isOpen"
  (click)="isOpen = !isOpen"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin"
>
  <i class="far fa-search tw-text-neutral-500"></i>
  <span class="tw-hidden tw-whitespace-nowrap tw-text-neutral-500 md:tw-inline">
    {{'core-lib.selectors.desk.button' | translate}}
  </span>
  <i class="fal fa-angle-down tw-hidden tw-text-base tw-ml-1 tw-text-neutral-400 md:tw-inline"></i>
</button>


<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOffsetX]="100"
  [cdkConnectedOverlayOpen]="isOpen"
>
<div id="overlaySelectorDesk" class="tw-mt-3 tw-max-w-[350px] md:tw-max-w-[450px]">
  <mh-core-lib-generic-box customClass="tw-h-fit">
    <mh-core-lib-autocomplete-input
        [options]="cases"
        [openBox]="true"
        [filterFn]="autocompleteFilterFn"
        [showGlassIcon]="true"
        [displayOptionsFn]="displayDeskOptions"
        [displayOptionsEmailFn]="displayIdOptions"
        (optionSelected)="handleCaseSelected($event)"
        >
    </mh-core-lib-autocomplete-input>
  </mh-core-lib-generic-box>
</div>

</ng-template>
